/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "右から左",
		"timeZoneID": "タイム・ゾーン",
		"skin": "スタイル",
		"metricsFileImportTask": "ファイルから新しくインポート",
		"displayMode": "デフォルトの表示",
		"credentialRenewed": "現在のユーザー ID とパスワードを使用して資格情報が更新されました。",
		"productLocale": "ユーザーインターフェイスの言語",
		"toggleDisabled": "オフ",
		"credentialChange": "更新",
		"log_level_Debug": "デバッグ",
		"confirmNewPassword": "新規パスワードの確認",
		"unsavedViewMsg2": "まず変更を保存しないと変更は失われます。",
		"supportPortalErrorMessage": "再試行してください。  問題が解決しない場合は、管理者に連絡してください。",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, the IBM logo, ibm.com and Cognos are trademarks or registered trademarks of International Business Machines Corp., registered in many jurisdictions worldwide. A current list of IBM trademarks is available on the Web at www.ibm.com/legal/copytrade.shtml. This Program is licensed under the terms of the license agreement accompanying the Program. この「プログラム」のご使用条件は、「プログラム」のディレクトリー・フォルダーまたはライブラリー内に「License」または「Non_IBM_License」として含まれるか、または印刷物として提供されます。 Please read the agreement carefully before using the Program. 「プログラム」をご使用になることで、お客様はこれらの条件に同意されたものとみなされます。",
		"groupsAndRoles": "グループと役割",
		"metricsMaintenanceTask": "新しく保守",
		"email": "E メール",
		"contextual": "コンテキスト",
		"resetHome": "デフォルトにリセット",
		"ltr": "左から右",
		"credentials": "資格情報",
		"logging_congfig_title": "ログ記録",
		"changePasswordTitle": "パスワードの変更",
		"format": "レポートの形式",
		"showUnread": "未読を表示する",
		"AILearning_active": "AI 学習が有効な場所:",
		"docsErrorMessage": "再試行してください。  問題が解決しない場合は、管理者に連絡してください。",
		"toggleEnabled": "オン",
		"homeSetError": "デフォルトのホーム・ページを設定しようとしてエラーが発生しました。このビューを閉じてから再び開いてください。",
		"passwordChange": "パスワードの変更",
		"profile": "プロファイル",
		"pdfRestricted": "PDF (制限付き)",
		"drillThrough": "ドリルスルー定義",
		"homeSet": "ホームが正常に設定されました",
		"regionalOptions": "領域オプション",
		"myPreferences": "個人用設定",
		"defaultHome": "デフォルト",
		"version": "バージョン",
		"controller": "Controller",
		"manage": "管理",
		"biDirectionalFeaturesEnabled": "双方向言語サポート",
		"newFeaturesErrorTitle": "新機能へのリンクが機能しませんでした",
		"passwordMatch": "パスワードが一致",
		"updateProfileAndsettings": "プロファイルおよび設定の更新",
		"dashboardConsole": "ワークスペース",
		"legacyAppsSlideoutLabel": "使用可能なレガシー・アプリケーション",
		"logging_config_description": "ロギングはトラブルシューティングのために使用します。 設定のガイダンスについては、管理者に問い合わせてください。",
		"confirmDeletion": "削除の確認",
		"signInButtonText": "ログイン",
		"dataSourceCredentials": "データ・サーバーの資格情報",
		"AILearningConfigurationSlideoutAllyLabel": "AI 学習の構成",
		"loadingSettings": "設定のロード中",
		"spreadsheetMLRestricted": "Excel (制限付き)",
		"manageAILearning": "AI 学習",
		"xlsxDataRestricted": "Excel データ (制限付き)",
		"advanced": "詳細オプション",
		"ok": "OK",
		"changeEmail": "変更",
		"showHints": "ヒントを表示する",
		"general": "全般",
		"xlsxData": "Excel データ",
		"newPassword": "新規パスワード",
		"hideAll": "すべて非表示",
		"confirmPassword": "パスワードの確認",
		"AILearning_config_description": "Cognos Analytics がお客様の使用法について学習することを許可して、製品内の推奨情報を改善します。",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "サポート・ポータルへのリンクが機能しませんでした",
		"log_level_Warn": "警告",
		"contentSettings": "コンテンツの設定",
		"setHomeButton": "セット",
		"myCapabilities": "個人用機能",
		"homePage": "ホーム・ページ",
		"helpErrorMessage": "再試行してください。  問題が解決しない場合は、管理者に連絡してください。",
		"loadingProfile": "プロファイルのロード中",
		"portal": "ポータル",
		"metricsPackage": "新しいパッケージ",
		"myCredentials": "自分の資格情報",
		"myApiKeys": "マイ API キー",
		"credentialCreate": "作成",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "パスワードを更新できません",
		"showHiddenObjects": "非表示のエントリーを表示",
		"csv": "CSV",
		"docsErrorTitle": "ドキュメンテーションへのリンクが機能しませんでした",
		"log_level_Error": "エラー",
		"wrongPassword": "認証できません",
		"productName": "IBM Cognos Analytics with Watson %{version}",
		"log_level_Info": "情報",
		"welcomeBanner": "ウェルカム・バナー",
		"helpErrorTitle": "ヘルプへのリンクが機能しませんでした",
		"contentLocale": "コンテンツ言語",
		"pdf": "PDF",
		"oldPassword": "旧パスワード",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "アクセシビリティ機能",
		"manageLogging": "ログ記録",
		"loggingConfigurationSlideoutA11yLabel": "ロギング構成",
		"communityErrorTitle": "コミュニティーへのリンクが機能しませんでした",
		"companionApps": "コンパニオン・アプリケーション",
		"setHomeLabel": "(現在のビュー) をホームに設定",
		"metricsExportTask": "新しくエクスポート",
		"csvRestricted": "CSV (制限付き)",
		"newFeaturesErrorMessage": "再試行してください。  問題が解決しない場合は、管理者に連絡してください。",
		"contributor": "Contributor",
		"showAll": "すべて表示",
		"logging_active": "ロギングがオン:",
		"html": "HTML",
		"profileAndSettings": "プロファイルおよび設定",
		"baseTextDirection": "テキストの基本方向",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "パスワード",
		"invalidEmail": "有効な E メール・アドレスを入力してください",
		"credentialCreateSuccess": "資格情報が正常に作成されました",
		"settings": "設定",
		"restrictedFormatSelected": "この形式でレポートを実行することはできませんが、この形式で保存されたレポートにアクセスすることはできます。",
		"usageDataDeletionConfirmation": "使用法データを削除すると、AI 学習がすべてリセットされます。使用法データを削除しますか?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "詳細の表示",
		"deleteUsageData": "使用法データの削除:",
		"showPassword": "パスワードの表示",
		"AILearning_config_title": "AI 学習",
		"myPreferencesSlideoutLabel": "プロファイルおよび設定",
		"passWordChangeSuccess": "パスワードが正常に変更されました",
		"logging_level": "ロギング・レベル:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "再試行してください。  問題が解決しない場合は、管理者に連絡してください。",
		"cancel": "キャンセル",
		"shareSetError": "この処理は、このビューを閉じて再び開かないと実行できません。",
		"passwordNotMatch": "パスワードが一致しません",
		"xml": "XML",
		"xmlRestricted": "XML (制限付き)",
		"openMenu": "「開く」メニュー",
		"closeMenu": '「閉じる」メニュー'
});